import { Component, OnInit } from '@angular/core';
import { GatesService } from '../_services/gates.service';
import { UntypedFormGroup, UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { GradeService } from '../_services/grades.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';


declare var $: any;

@Component({
  selector: 'app-assign-gate-modal',
  templateUrl: './assign-gate-modal.component.html',
  styleUrls: ['./assign-gate-modal.component.scss']
})
export class AssignGateModalComponent implements OnInit {
  gate;
  gates = [];
  grades = [];
  allGates = [];
  assignGatesToGradesForm: UntypedFormGroup;

  constructor(private gatesService: GatesService, private gradesService: GradeService, private translate: TranslateService,private dataService: DataService) { }

  ngOnInit(): void {
    $('#assignGateModal').on('hidden.bs.modal', () => {
      this.grades_ids.clear();
    })

    $('#assignGateModal').on('shown.bs.modal', () => {
      this.dataService.getAllGates().subscribe((res: any) => {
        this.allGates = res;
      })
    })

    this.assignGatesToGradesForm = new UntypedFormGroup({
      grades_ids: new UntypedFormArray([])
    })

    this.dataService.getAllGates().subscribe((res: any) => {
      this.allGates = res;
    })

    this.gatesService.getGateData().subscribe(res => {
      if (res) {
        this.gate = res;
        while (this.grades_ids.controls.length !== 0) {
              this.grades_ids.removeAt(0)
            }
        this.gate.grades.map(grade => {
          this.grades_ids.push(new UntypedFormControl('', Validators.required));
          this.grades.push(grade)
        })
        this.gates = this.allGates.filter(gate => gate.id !== this.gate.id)
      }
    })
  }

  // getters method
  get grades_ids(): UntypedFormArray {
    return this.assignGatesToGradesForm.get('grades_ids') as UntypedFormArray;
  }

  async assignGatesToGrade() {
    let promise = new Promise((resolve, reject) => {
      this.grades.map((grade, idx) => {
        let body = { gates_ids: this.assignGatesToGradesForm.value.grades_ids[idx] };
        this.gradesService.updateGrade(body, grade.id).subscribe(res => {
          resolve(true)
        })
      })
    })
    let result = await promise;
    if (result) {
      this.gatesService.deleteGate(this.gate.id).subscribe(res => {
        this.gatesService.setGatesReload();
        this.grades_ids.clear();
        $("#deleteModal").modal("hide");
        $("#assignGateModal").modal("hide");
      })
    }
  }

  getAssignFormValidation(control) {
    let errorMsg;
    if (control.errors) {
      errorMsg = control.errors.required ? this.translate.instant('gates.gate-required') : this.translate.instant('gates.gate-invalid');
    }
    return errorMsg
  }
}
